var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisputes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_convert-card",
    "data-name": "vuesax/bulk/convert-card",
    transform: "translate(-556 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "convert-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(556 316)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.39,12.218a.061.061,0,0,0,.02-.039L12.179,1.41c.02-.02.039-.019.059-.039A7.816,7.816,0,0,0,0,7.832a7.677,7.677,0,0,0,1.136,4.033A3.971,3.971,0,0,1,1.39,12.218Z",
    transform: "translate(560.158 320.168)",
    fill: "#fdbc3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.867,0c-.02.02-.019.039-.039.059L.059,10.828c-.02.02-.039.019-.059.039A7.789,7.789,0,0,0,11.1,8.439a7.677,7.677,0,0,0,1.136-4.033A7.73,7.73,0,0,0,10.867,0Z",
    transform: "translate(563.604 323.594)",
    fill: "#fdbc3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_",
    "data-name": "Vector (Stroke)",
    d: "M7.75,0A.75.75,0,0,1,8.5.75,7.745,7.745,0,0,1,.75,8.5.75.75,0,0,1,.107,7.364l1.05-1.75a.75.75,0,1,1,1.286.772l-.271.452A6.246,6.246,0,0,0,7,.75.75.75,0,0,1,7.75,0Z",
    transform: "translate(570.25 330.25)",
    fill: "#fdbc3d",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_2",
    "data-name": "Vector (Stroke)",
    d: "M6.328,1.662A6.246,6.246,0,0,0,1.5,7.75a.75.75,0,0,1-1.5,0A7.745,7.745,0,0,1,7.75,0a.75.75,0,0,1,.643,1.136l-1.05,1.75a.75.75,0,1,1-1.286-.772Z",
    transform: "translate(557.25 317.25)",
    fill: "#fdbc3d",
    opacity: 0.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputes);
export default __webpack_public_path__ + "static/media/disputes.9f768877f0eefa1538ded0561ce063b6.svg";
export { ForwardRef as ReactComponent };